import AudioManager from "scripts/util/AudioManager";
import Main from "scripts/3d/experience/Main";
import * as BABYLON from "babylonjs";
import EventPubSub from "scripts/util/EventPubSub";
import AssetLoader from "../loaders/AssetLoader";
// import { BabylonFileLoaderConfiguration } from "babylonjs";
// import * as MATERIALS from "babylonjs-materials";

class Present {
  constructor(mesh, index, levelKey, isNewPowerUp) {
    this.view = new BABYLON.TransformNode(
      "PresentContainer L-" + levelKey + ":" + index
    );
    this.view.rotationQuaternion = null;
    this.isNewPowerUp = isNewPowerUp;
    this.present = mesh;
    // this.present.useVertexColors=false;

    this.points = 50;
    if(isNewPowerUp) this.points=100;
    this.rotDir = 0.05;

    mesh.rotationQuaternion = null;
    this.present.parent = this.view;

    this.index = index;

    if (this.isNewPowerUp) {
      // if watch
      if (index === 1) {
        // this.present.rotation.x = Math.PI;
        this.present.rotation.z = Math.PI + Math.PI / 2;
      } else if (index === 2) {
        //headphones
        this.present.rotation.x = Math.PI / 2;
      } else {
        //phone
        this.present.rotation.x = Math.PI / 2;
      }
    }

    this.isAir = this.present.name.includes("Air");

    this.present.position.y = this.isAir ? 2.3 : 0.5;
    this.isHit = false;

    this.present.position.y = this.isAir ? 2.3 : 0.5;
    // if (!this.isAir) {
    this.present.rotation.y = Math.random(1.5) + 2.4;
    // }
    this.isHit = false;

    this.collider = BABYLON.MeshBuilder.CreateBox("PresentCollider" + index, {
      size: 0.9,
    });
    this.collider.position.y = this.isAir ? 2.7 : 0.4;
    this.collider.parent = this.view;
    this.collider.isVisible = false;

    this.particleSystem = new BABYLON.GPUParticleSystem(
      "giftParticles L-" + levelKey + ":" + index,
      48
    );
    // this.particleSystem.particleTexture =
    //   AssetLoader.getTexture("PresentSparks");
    // if(this.isNewPowerUp)
    // {
    //   this.particleSystem.particleTexture =
    //   AssetLoader.getTexture("PowerSprites" + this.index);
    //   this.particleSystem.endSpriteCellID = 3;
    // }
    // else
    // {
      this.particleSystem.particleTexture =
      AssetLoader.getTexture("PresentSparks");
      this.particleSystem.endSpriteCellID = 2;
    // }
    this.particleSystem.startSpriteCellID = 0;
    // this.particleSystem.endSpriteCellID = 2;
    this.particleSystem.spriteCellHeight = 128;
    this.particleSystem.spriteCellWidth = 128;
    this.particleSystem.spriteRandomStartCell = true;
    // particleSystem.spriteCellChangeSpeed = .1;
    this.particleSystem.isAnimationSheetEnabled = true;
    this.particleSystem.minLifeTime = 0.2;
    this.particleSystem.maxLifeTime = 1;
    this.particleSystem.emitRate = 13;
    this.particleSystem.isLocal = true;
    this.particleSystem.minSize = 0.2;
    this.particleSystem.maxSize = 0.4; //0.3
    this.particleSystem.color1 = new BABYLON.Color4(1, 1, 1, 0);
    this.particleSystem.color2 = new BABYLON.Color4(1, 1, 1, 1);
    this.particleSystem.colorDead = new BABYLON.Color4(1, 1, 1, 0);
    this.particleSystem.blendMode = BABYLON.ParticleSystem.BLENDMODE_ADD; //ADD;
    this.particleSystem.particleEmitterType.directionRandomizer = 1;
    this.particleSystem.direction1 = new BABYLON.Vector3(0.2, 0.5, 0);
    this.particleSystem.direction2 = new BABYLON.Vector3(-0.2, 0.5, 0);
    this.particleSystem.billboardMode = BABYLON.AbstractMesh.BILLBOARDMODE_ALL;

    //bump down emitter
    this.meshEmitter = BABYLON.MeshBuilder.CreateBox("emitterBox1", {
      height: 1,
      width: 1,
      depth: 1,
    });
    // this.meshEmitter.parent = mesh;
    this.meshEmitter.position.y = 0.6;
    if (this.isAir) this.meshEmitter.position.y += 1.8;
    mesh.addChild(this.meshEmitter);
    this.meshEmitter.isVisible = false;
    this.meshEmitter.isBlocker = false;
    this.particleSystem.emitter = this.meshEmitter;
    this.particleSystem.start();
    this.particleSystem.parent = this.present;
  }

  setConfig(config) {
    this.config = config;

    const { position, rotation, scaling } = this.config;

    this.view.rotation = rotation.clone();
    this.view.position = position.clone();
    this.view.scaling = scaling.clone();
  }

  update() {
    if (this.present)
      if (!this.isHit && this.present.isVisible) {
        if (this.isNewPowerUp && this.index === 1) {
          if (this.present.rotation.y >= 4) {
            this.present.rotation.y = 4;
            this.rotDir = -0.05;
          }
          if (this.present.rotation.y <= 2.3) {
            this.present.rotation.y = 2.3;
            this.rotDir = 0.05;
          }
          this.present.rotation.y += this.rotDir; // 0.05;
        }
        else this.present.rotation.y += .05;
      }
  }

  hit() {
    this.isHit = true;
    this.present.isVisible = false;
    this.particleSystem.stop();
    this.particleSystem.reset();
    AudioManager.playSound("present");
    if(this.isNewPowerUp) Main.VFX.stars(this.index);
    else Main.VFX.stars(0);
    EventPubSub.emit("collectGift");
  }

  reset() {
    this.view.isVisible = true;
    this.isHit = false;
    // this.particles.start()
  }

  destroy() {
    this.collider.parent = null;
    this.collider.isVisible = false;
    this.collider.dispose();

    this.present.parent = null;
    this.present.isVisible = false;
    // this.present.dispose();

    this.view.parent = null;
    this.view.isVisible = false;
    this.view.dispose();

    // this.particleSystem.dispose()
    // this.particleSystem = null
    this.particleSystem.stop();
  }
}

export default Present;
